export const baseURL = "https://api.primexloyalty.com/Merchant/api/";
